/**
 * Theme entry point.
 *
 * Keep this file small. It should only orchestrate modules.
 */

import { domReady } from './core/dom-ready.js';
import { initHeader } from './core/header.js';
import { initComponentModules } from './components/index.js';
import { initSectionModules } from './sections/index.js';
import { initPageModules } from './pages/index.js';

domReady(() => {
  initHeader(document);
  initComponentModules(document);
  initSectionModules(document);
  initPageModules(document);
});
